export const unknownField = (field) => `<unknown-${field}>`;

const shortHash = (hash) => (typeof hash === 'string' ? hash.substring(0, 9) : undefined);

// Remove hyphens and colons from ISO timestamp
const formatTimestamp = (isoString) =>
  typeof isoString === 'string' ? isoString.replace(/[-:]/g, '') : undefined;

export function releaseId(Updates, Constants, env) {
  const isOTA = Updates?.isEmbeddedLaunch === false;
  // This will be true if the currently running update is the one embedded in the build, and not one downloaded from the
  // updates server.
  //
  // https://docs.expo.dev/versions/latest/sdk/updates/#updatesisembeddedlaunch

  const buildType = isOTA ? 'OTA' : 'BLD';

  const nativeVersion = Constants?.expoConfig?.version || Updates?.manifest?.extra?.expoClient?.version;
  const appEnvironment = Constants?.expoConfig?.extra?.APP_ENV;

  let timestamp;
  let fingerprintHash;
  let commitHash;

  if (isOTA) {
    // OTA update: use update manifest data
    const manifest = Updates?.manifest;
    timestamp = manifest?.createdAt;
    fingerprintHash = Updates?.runtimeVersion;
    commitHash =
      Constants?.expoConfig?.extra?.gitCommitHash || manifest?.extra?.expoClient?.extra?.gitCommitHash;
  } else {
    // Native build: use embedded environment variables
    commitHash = env ? env.EXPO_PUBLIC_PTF_GIT_COMMIT_HASH : process.env.EXPO_PUBLIC_PTF_GIT_COMMIT_HASH;
    fingerprintHash = env
      ? env.EXPO_PUBLIC_PTF_EXPO_FINGERPRINT
      : process.env.EXPO_PUBLIC_PTF_EXPO_FINGERPRINT;
    timestamp = env ? env.EXPO_PUBLIC_PTF_BUILD_DATETIME : process.env.EXPO_PUBLIC_PTF_BUILD_DATETIME;
  }

  // Format: nativeVersion:appEnvironment:fingerprint:buildType:timestamp:commit
  return [
    nativeVersion || unknownField('version'),
    appEnvironment || unknownField('appenv'),
    shortHash(fingerprintHash) || unknownField('fingerprint'),
    buildType,
    formatTimestamp(timestamp) || unknownField('timestamp'),
    shortHash(commitHash) || unknownField('commit'),
  ].join(':');
}
